import { Link } from 'react-router-dom';
import ContentWrapper from '../../views/components/ContentWrapper';
import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { changePassword } from '../../data/dataApi';
import ConfirmationModal from '../../views/components/ConfirmationModal';
import PasswordField from "../../views/components/PasswordField";

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState();
    const [oldPasswordError, setOldPasswordError] = useState();
    const [newPassword, setNewPassword] = useState();
    const [newPasswordError, setNewPasswordError] = useState();
    const [unexpectedError, setUnexpectedError] = useState();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const handleChangePassword = () => {
        setOldPasswordError("");
        setNewPasswordError("");
        setUnexpectedError("");

        if(!oldPassword) {
            setOldPasswordError("Please enter the old password.");
        } else if(!/^(?=.*[A-Z])(?=.*\d).{8,}$/.test(newPassword)) {
            setNewPasswordError("Password must be at least 8 characters long and include 1 capital letter and 1 number.");
        } else {
            (async () => {
                const response = await changePassword(oldPassword, newPassword);

                if(response.success) {
                    setShowConfirmationModal(true);
                } else if(response.error && response.error.field === "oldPassword") {
                    setOldPasswordError(response.error.message);
                } else if(response.error) {
                    setUnexpectedError(response.error.message);
                }
            })();
        }
    };
    
    return (
        <>
            <ContentWrapper>
                <div id="user-accounts" className="wrapper">
                    <Link to="/dashboard/user-accounts" className="dashboard-tertiary-btn tif-mb-md-50 tif-mb-25">Back</Link>

                    <Form className="secondary-form">
                        <Form.Group className="form-group tif-mb-md-35 tif-mb-20" controlId="formOldPassword">
                            <Form.Label>Old Password</Form.Label>
                            <PasswordField onChange={ setOldPassword } error={ oldPasswordError } placeholder="Type here" />
                            { oldPasswordError && <p className="error-text">{ oldPasswordError }</p> }
                        </Form.Group>

                        <Form.Group className="form-group" controlId="formNewPassword">
                            <Form.Label>New Password</Form.Label>
                            <PasswordField onChange={ setNewPassword } error={ newPasswordError } placeholder="Type here" />
                            { newPasswordError && <p className="error-text">{ newPasswordError }</p> }
                        </Form.Group>

                        { unexpectedError && <p className="error-text">{ unexpectedError }</p> }

                        <Button className="dashboard-quarternary-btn tif-mt-md-55 tif-mt-30" onClick={ handleChangePassword }>Change Password</Button>
                    </Form>
                </div>
            </ContentWrapper>
            <ConfirmationModal show={ showConfirmationModal } changeVisibility={ setShowConfirmationModal } type="success" successMessage="Password changed successfully!" close={
                <Link to="/dashboard/user-accounts" className="dashboard-tertiary-btn">
                    Back to User Accounts
                </Link>
            } />
        </>
    );
};

export default ChangePassword;
